module.exports = __webpack_public_path__ + "static/img/7.fe96f36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chongqing/7.jpg
// module id = lxWZ
// module chunks = 1